import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

import accountStore from './account'
import app from './generalModules/app'
import settings from './generalModules/settings'
import user from './generalModules/user'
import companyStore from './company';
import usersInfoStore from './../views/user-information/store';
import reportContract from './../views/report-contract/store';
import reportCompany from './../views/report-company/store';
import classStore from './../views/class/store';

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    accountStore,
    app,
    settings,
    user,
    companyStore,
    usersInfoStore,
    reportStore: reportContract,
    reportCompany,
    classStore,
  },
  getters
})

export default store